export default __webpack_public_path__ + "static/media/time-icon.9927feab.svg";